import { Select } from "antd";
import { useFormStructureSelectOptions } from "components/UI/Selects/FormStructureSelectSearchable/useFormStructureSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

import FilterRequest = App.Http.Requests.FilterRequest;

type FormStructureSelectSearchableProps = SearchableSelectWrapperProps & {
    filter?: FilterRequest;
    useSystemNameAsValue?: boolean;
};

export const FormStructureSelectSearchable = ({
    filter,
    useSystemNameAsValue = false,
    ...props
}: FormStructureSelectSearchableProps) => {
    const hookResult = useFormStructureSelectOptions({ filter, useSystemNameAsValue });

    if (hookResult.loading && !hookResult.options.length) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.form_structure"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
